import React, { useState } from 'react';
import { Shield, Lock, MapPin, Store } from 'lucide-react';
import { Language } from '../types/spot';
import { PrivacyModal } from './PrivacyModal';

interface PrivacyFooterProps {
  language: Language;
  onOpenVeggieSnacks?: () => void;
}

export const PrivacyFooter: React.FC<PrivacyFooterProps> = ({ language, onOpenVeggieSnacks }) => {
  const [modalTab, setModalTab] = useState<'privacy' | 'imprint' | null>(null);

  const t = {
    de: {
      tagline: 'Dein unabhängiger Reiseführer & Fotospot-Navigator für Südkorea.',
      gpsChip: 'GPS nur lokal im Browser',
      safeChip: 'Ohne Tracking-Cookies',
      privacyBtn: 'Datenschutz',
      imprintBtn: 'Impressum',
      veggieSnacksBtn: '24/7 Veggie Snacks',
    },
    en: {
      tagline: 'Independent travel guide and photo spot navigator for South Korea.',
      gpsChip: 'Client-side GPS only',
      safeChip: 'Zero tracking cookies',
      privacyBtn: 'Privacy Policy',
      imprintBtn: 'Legal Notice / Imprint',
      veggieSnacksBtn: '24/7 Veggie Snacks',
    },
    kr: {
      tagline: '한국 여행자를 위한 독립 가이드 및 포토스팟 내비게이터.',
      gpsChip: 'GPS 브라우저 로컬 처리',
      safeChip: '추적 쿠키 없음',
      privacyBtn: '개인정보 처리방침',
      imprintBtn: '사업자 정보 (Impressum)',
      veggieSnacksBtn: '24/7 편의점 채식 간식',
    },
  }[language];

  return (
    <>
      <footer className="app-privacy-footer">
        <div className="app-privacy-footer__inner">
          <div className="app-privacy-footer__info">
            <div className="app-privacy-footer__title">
              <span className="app-privacy-footer__flag">🇰🇷</span>
              <span className="app-privacy-footer__name">K-SpotFinder</span>
              <span className="app-privacy-footer__badge">KOREA</span>
            </div>
            <p className="app-privacy-footer__subtext">
              {t.tagline}
            </p>
          </div>

          <div className="app-privacy-footer__chips">
            <span className="app-privacy-chip">
              <MapPin style={{ width: 12, height: 12, color: 'var(--success)' }} />
              <span>{t.gpsChip}</span>
            </span>
            <span className="app-privacy-chip">
              <Lock style={{ width: 12, height: 12, color: 'var(--text-secondary)' }} />
              <span>{t.safeChip}</span>
            </span>
          </div>

          <div className="app-privacy-footer__action">
            <button
              onClick={() => setModalTab('privacy')}
              className="footer-link-btn"
            >
              <Shield style={{ width: 13, height: 13 }} />
              <span>{t.privacyBtn}</span>
            </button>
            <span style={{ color: 'var(--border)' }}>·</span>
            <button
              onClick={() => setModalTab('imprint')}
              className="footer-link-btn"
            >
              <span>{t.imprintBtn}</span>
            </button>
            {onOpenVeggieSnacks && (
              <>
                <span style={{ color: 'var(--border)' }}>·</span>
                <button
                  onClick={onOpenVeggieSnacks}
                  className="footer-link-btn"
                  style={{ color: '#34d399' }}
                >
                  <Store style={{ width: 13, height: 13 }} />
                  <span>{t.veggieSnacksBtn}</span>
                </button>
              </>
            )}
          </div>
        </div>
      </footer>

      {modalTab && (
        <PrivacyModal
          isOpen={true}
          onClose={() => setModalTab(null)}
          language={language}
          initialTab={modalTab}
        />
      )}
    </>
  );
};
